import * as Yup from 'yup'

export const changeRoomsSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
})
